module.exports = __webpack_public_path__ + "img/3.6d075e0c.jpg";